<template>
  <TableGradient
      icon-name="filter"
      :title="$t('tuevs.complement.listagem.titulo_pagina')"
      :items="complements"
      table-data
      :fields="fields"
      :loading="isLoading"
      :paginator="pagination"
      :text-empty="$t('tuevs.complement.listagem.table.empty')"
      route-new="tuevs.complements.create"
      :text-new="$t('tuevs.complement.listagem.novo')"
      @list="evt => $store.dispatch('tuevs/complement/listAll', evt)">
    <template v-slot:cell(status)="linha">
            <span
                :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
                <em v-if="linha.item.status">{{ $t('tuevs.complement.listagem.habilitado') }}</em>
                <em v-else>{{ $t('tuevs.complement.listagem.desabilitado') }}</em>
            </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index"
                   :to="{ name: 'tuevs.complements.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('tuevs.complement.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(specimens)="linha">
      <span v-if="linha.item.specimens && linha.item.specimens.length">{{ linha.item.specimens[0].name }}</span>
      <span
          v-if="linha.item.specimens && linha.item.specimens.length > 1"
          class="badge badge-light ml-1"
          v-b-tooltip.hover
          :title="linha.item.specimens.slice(1).map(specimen => specimen.name).join(', ')"
      >
        +{{ linha.item.specimens.length - 1 }}
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/complement/isLoading',
      complements: 'tuevs/complement/all',
      pagination: 'tuevs/complement/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('tuevs.complement.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tuevs.complement.listagem.table.codigo'), sortable: true},
        {key: 'specimens', label: this.$t('tuevs.exams.form.fields.material.label')},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tuevs.complement.listagem.table.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/complement/listAll'
    ])
  },
  mounted() {
    this['tuevs/complement/listAll']()
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
